import { render } from "./NewForgotPassword.vue?vue&type=template&id=a79692f8&scoped=true"
import script from "./NewForgotPassword.vue?vue&type=script&lang=js"
export * from "./NewForgotPassword.vue?vue&type=script&lang=js"

import "./NewForgotPassword.vue?vue&type=style&index=0&id=a79692f8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a79692f8"]])

export default __exports__